import { Station, StationAccessType } from '@mi-front/core';

export function isVideoStation(station: Station) {
  return station?.format === 'mpegts';
}

export function isAudioStation(station: Station) {
  return !isVideoStation(station);
}

/**
 * Returns true when the station is owned by the authenticated client.
 */
export function isOwnedStation(station: Station) {
  return station.accessType === StationAccessType.OWNED;
}

/**
 * Returns true when the station is shared from another client.
 */
export function isSharedStation(station: Station) {
  return station.accessType === StationAccessType.SHARED;
}

/**
 * Defines whether write-capable station surfaces should be shown.
 */
export function canEditStation(station: Station) {
  return isOwnedStation(station);
}
